export default function extractCssFromViteHmr(
  cssContent: string
): string | null {
  try {
    // Look for this pattern in the Vite HMR wrapper
    const cssStartMarker = 'const __vite__css = "';

    // Find the start of the CSS content
    const cssStartIndex = cssContent.indexOf(cssStartMarker);
    if (cssStartIndex === -1) return null;

    // Adjust index to start after the marker
    const contentStartIndex = cssStartIndex + cssStartMarker.length;

    // Find the end of the CSS content
    // We need to find the correct closing quote that isn't escaped
    let endIndex = contentStartIndex;
    let escaped = false;

    while (endIndex < cssContent.length) {
      const char = cssContent[endIndex];

      if (char === '\\' && !escaped) {
        escaped = true;
      } else if (char === '"' && !escaped) {
        break; // Found the end of CSS content
      } else {
        escaped = false;
      }

      endIndex++;
    }

    if (endIndex >= cssContent.length) return null;

    // Extract and decode the CSS content
    const encodedCss = cssContent.substring(contentStartIndex, endIndex);

    // Unescape escaped characters (like \" and \\)
    return encodedCss
      .replace(/\\"/g, '"')
      .replace(/\\\\/g, '\\')
      .replace(/\\r\\n/g, '\n')
      .replace(/\\n/g, '\n');
  } catch (error) {
    console.error('Failed to extract CSS from Vite HMR content:', error);
    return null;
  }
}
